import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import { merge } from 'rxjs';
import { Channel } from '../../../models';
import { ChatService } from '../chat.service';
import { ChatActionTypes } from '../ngrx/actions';

@Component({
  selector: 'bidi-chat-panel',
  templateUrl: './chat-panel.component.html',
  styleUrls: ['./chat-panel.component.scss']
})
export class ChatPanelComponent implements OnInit, OnDestroy {
  @ViewChild('chat') chat: ElementRef;

  form: {
    message: string;
  };

  private subscription;

  constructor (public chatService: ChatService, private actions: Actions) {
    this.resetForm();
  }

  ngOnInit () {
    this.subscription = merge(
      this.chatService.selectedChannel$,
      this.actions.pipe(ofType(ChatActionTypes.INCOMING_MESSAGE))
    ).subscribe(() => {
      setTimeout(() => {
        if (this.chat) {
          this.chat.nativeElement.scrollTop = this.chat.nativeElement.scrollHeight;
        }
      }, 10);
    });
  }

  ngOnDestroy () {
    this.subscription.unsubscribe();
  }

  submit (form, channel: Channel) {
    this.chatService.send(form.message, channel);
    this.resetForm();
  }

  resetForm () {
    this.form = { message: '' };
  }
}
